import { AppState } from 'src/store/app/types';
import { PayloadAction } from '@reduxjs/toolkit';

const setAppBackUrlReducer = (state: AppState, action: PayloadAction<string | undefined>) => {
  state.backUrl = action.payload;
};

export default setAppBackUrlReducer;
